module.exports = __webpack_public_path__ + "static/img/4295_phase_function_Paper_Points.fc4fb14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4295_phase_function_Paper_Points.png
// module id = 6ps7
// module chunks = 0